import { useSelector } from 'react-redux';
import { getModulePrivs } from '../redux/selectors/modules';
import { useGruser } from './useGruser';
import { PapiModuleData } from '@wix/da-papi-types';

export default function (moduleId: number): PapiModuleData['privileges'] | undefined {
  const { gruser } = useGruser();
  const modulePrivs = useSelector((state: any) => getModulePrivs(state, gruser, moduleId));
  return modulePrivs;
}
